export default __webpack_public_path__ + "static/media/trophy3.1fbc280e.svg";